import React from 'react';
import styled from 'styled-components';
import { Grid, Breakpoints } from '../../app/StyleGuide';
import LoadingState from '../../components/LoadingState';
import ErrorMessage from '../../components/ErrorMessage';
import { Container, FixedHeaderContainer, FixedHeaderContent } from '../../components/Layout';
import { LinkStyleButton, PrimaryButton, RoundedIconButton } from '../../components/Buttons';
import ActionableTitleBar from '../../components/ActionableTitleBar';
import { useSelectOrgForChurchCares } from './hooks/useSelectOrgForChurchCares';
import { RaisedChurchListItem } from './components/RaisedChurchListItem';

const ChurchList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${Grid._6};
  margin-top: ${Grid._10};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Grid._4};
  text-align: center;
  margin-top: ${Grid._7};
  padding-bottom: ${Grid._10};

  button {
    min-width: 134px;

    @media screen and (min-width: ${Breakpoints.screen_sm}) {
      margin: 5px;
    }
  }
`;

const PrimaryButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    width: 180px;
  }
`;

const LinkStyleButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    width: auto;
    min-width: auto;
  }
`;

export const SelectOrgForChurchCares = () => {
  const {
    isLoading,
    isError,
    isSubmitting,
    orgs,
    selectedOrgId,
    setSelectedOrgId,
    submitOrgChange,
    redirectBacktoOnboarding,
    redirectToDashboard,
    hasAssignViewPermission,
  } = useSelectOrgForChurchCares();

  return (
    <FixedHeaderContainer fullViewport>
      <ActionableTitleBar
        title="Select A Church"
        subtitle=""
        leftButton={<div />}
        rightButton={
          <RoundedIconButton data-qa-hook="back" onClick={redirectToDashboard}>
            <i className="fas fa-times fa-fw"></i>
            Close
          </RoundedIconButton>
        }
      />
      <FixedHeaderContent>
        <Container>
          {isLoading ? (
            <LoadingState />
          ) : isError ? (
            <ErrorMessage />
          ) : (
            <>
              <ChurchList>
                {orgs.map(org => (
                  <RaisedChurchListItem
                    church={org}
                    selected={org._id.id === selectedOrgId}
                    onButtonClick={() => setSelectedOrgId(org._id.id)}
                    key={org._id.id}
                  />
                ))}
              </ChurchList>

              <ButtonContainer>
                {selectedOrgId && !hasAssignViewPermission && (
                  <ErrorMessage>
                    You are unable to assign training in this church. Please select another church to continue.
                  </ErrorMessage>
                )}
                <PrimaryButtonWrapper>
                  <PrimaryButton
                    onClick={submitOrgChange}
                    disabled={!selectedOrgId || !hasAssignViewPermission || isSubmitting}
                    operating={isSubmitting}
                  >
                    Continue
                  </PrimaryButton>
                </PrimaryButtonWrapper>
                <LinkStyleButtonWrapper>
                  <LinkStyleButton onClick={redirectBacktoOnboarding} operating={isSubmitting}>
                    Start Over
                  </LinkStyleButton>
                </LinkStyleButtonWrapper>
              </ButtonContainer>
            </>
          )}
        </Container>
      </FixedHeaderContent>
    </FixedHeaderContainer>
  );
};
